<ng-container *ngIf="bookingStore.loaded$ | async; else loader">
  <div *ngIf="bookingStore.selectedPlan$ | async" class="summary">
    <h3 class="summary-title">{{ '+BOOKING.SUMMARY.SHOPPING_CART' | translate }}</h3>
    <ng-container *ngIf="bookingStore.subscriptionsDetailsLoaded$ | async; else loader">
      <ng-container *ngIf="subscriptionsDetails?.price as price">
        <div class="summary-cart">
          <div class="cart-entry">
            <span data-at-selected-package="Pro">{{
              '+BOOKING.SUMMARY.PLAN.PRO' | translate
            }}</span>
            <div>
              <span>1x</span>
              <span>{{ price.net.toFixed(2) | number: '1.2-2':'de-DE' }} {{ price.currency }}</span>
            </div>
          </div>
        </div>
        <div class="summary-discounts">
          <div class="discounts-entry">
            <span class="vat">{{
              '+BOOKING.PRICE.TAX_RATE' | translate: { taxRate: price.taxRate }
            }}</span
            ><span data-at-tax class="discounts-entry-price"
              >{{ price.tax | number: '1.2-2':'de-DE' }} {{ price.currency }}</span
            >
          </div>
        </div>

        <div class="summary-br"></div>
        <div class="summary-total-price">
          {{ price.total.toFixed(2) | number: '1.2-2':'de-DE' }} {{ price.currency }}
        </div>

        <div class="summary-tos" *ngIf="documentsStore.termsOfUseDocument$ | async as document">
          <mat-checkbox
            data-at-terms-of-use-checkbox
            gtm="onToggle"
            gtmAction="Booking Checkout"
            gtmCategory="booking"
            [(ngModel)]="tosAccepted"
            (ngModelChange)="onTosCheckboxChange($event)"
          >
          </mat-checkbox>
          <span
            [innerHTML]="
              '+BOOKING.SUMMARY_USER_AGGREEMENT.TEXT'
                | translate
                | link: '{key}':'+BOOKING.SUMMARY_USER_AGGREEMENT.KEY_TRANSLATION':document.link
            "
          ></span>
        </div>
        <button
          data-at-checkout-button
          gtm="onGoToPage"
          gtmAction="Booking Checkout"
          gtmCategory="booking"
          class="summary-btn-continue"
          [disabled]="!tosAccepted || !(bookingStore.loaded$ | async)"
          mat-raised-button
          color="primary"
          (click)="onContinue()"
        >
          <span>{{ '+BOOKING.SUMMARY.BTN.SUBSCRIBE' | translate }}</span>
        </button>
      </ng-container>
    </ng-container>
  </div>
</ng-container>

<ng-template #loader>
  <vi-loader data-at-loader-booking [isLoading]="true"></vi-loader>
</ng-template>
